import { inject, Injectable } from "@angular/core";
import { ActivatedRoute, Data, NavigationEnd, Router } from "@angular/router";
import { filter, map, Observable, shareReplay, startWith, withLatestFrom } from "rxjs";

type ActiveAppRoute = {
    url: string;
    routerData: Data;
    activatedRoute: ActivatedRoute;
    state: unknown;
};

@Injectable({
    providedIn: "root",
})
export class RoutingService {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);

    public routingEvents: Observable<ActiveAppRoute> = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(event => event.urlAfterRedirects),
        startWith(this.router.url),
        withLatestFrom(this.activatedRoute.data),
        map(([url, routerData]) => {
            return {
                url,
                routerData,
                activatedRoute: this.activatedRoute,
                state: this.router.getCurrentNavigation()?.extras.state,
            };
        }),
        shareReplay(1),
    );

    private routingSubscription = this.routingEvents.subscribe();
}
